import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function incidentReporteDataReducer(state = initialState.incidentReporteData, action) {
  switch (action.type) {
    case types.LOAD_INCIDENT_REPORTE_DATA_SUCCESS:
      return action.incidentReporteData;
    default:
      return state;
  }
}
